import Auth from '@aws-amplify/auth';
export const signOut = () => {
    const oauthConfig = Auth.configure(undefined).oauth;
    if (!oauthConfig)
        throw new Error('Unable to retrieve Auth configuration.');
    const signOutUrl = `https://${oauthConfig.domain}/logout?client_id=${oauthConfig.clientId}&logout_uri=${oauthConfig.redirectSignOut}`;
    window.location.replace(signOutUrl);
};
